import { useEffect } from "react";

const DEFAULT_TITLE = "Sofiane Amroune | Développeur web sénior";
const DEFAULT_DESCRIPTION =
  "Site professionnel de Sofiane Amroune, développeur web sénior polyvalent, intervenant sur le frontend, le backend et la modernisation d’applications web.";
const DEFAULT_ROBOTS = "noindex,nofollow,noarchive";

function updateMetaTag(name, content) {
  const metaTag = document.querySelector(`meta[name="${name}"]`);

  if (metaTag) {
    metaTag.setAttribute("content", content);
    return;
  }

  const createdMetaTag = document.createElement("meta");
  createdMetaTag.setAttribute("name", name);
  createdMetaTag.setAttribute("content", content);
  document.head.appendChild(createdMetaTag);
}

function usePageMeta({ title, description, robots = DEFAULT_ROBOTS }) {
  useEffect(() => {
    document.title = title ? `${title} | Sofiane Amroune` : DEFAULT_TITLE;
    updateMetaTag("description", description || DEFAULT_DESCRIPTION);
    updateMetaTag("robots", robots);
  }, [description, robots, title]);
}

export default usePageMeta;
